// extracted by mini-css-extract-plugin
export default {"containerGroup":"dataGroup_containerGroup__1QH4g","titleValue4":"dataGroup_titleValue4__yzTPA"};